/**
 * GLOBAL LAYER STACK (BOTTOM → TOP)
 */

export const LAYER_STACK = [
    "search-aoi",
    "detected",
    "stac",
    "preview",          // raster
    "uploaded",
    "order-preview",
    "orbit",
    "draw"
  ];

export const MAP_CENTER = [78.6677428, 22.3511148];

export const MAP_DEFAULT_ZOOM = 3;

export const MAP_VIEWS = [
    { 
        name: 'Falt Earth View',
        dimension: 'mercator',
    },
    {
        name: '3D Globe View',
        dimension: 'globe',
    },
];

export const MAP_STYLES = [
    { 
        name: 'Mapbox Dark',
        style: 'dark-v11',
    },
    { 
        name: 'Mapbox Light',
        style: 'light-v11',
    },
    { 
        name: 'Mapbox Satellite',
        style: 'satellite-v9'
    },
];

export const GEODATA_OPTIONS = [
    {
        name: 'Orders',
        type: 'orders',
    },
    {
        name: 'Leagacy Data',
        type: 'legacyData',
    },
]


export const PROVIDER_ORBIT_COLORS = {
    default: '#EBBE4D',      // blue
    risat: '#FF7F7F',   // red
    iceye: '#FF7F7F',   // red
    umbra: '#FF7F7F',   // red
};
  